import React from 'react';
import { Checkbox as AntdCheckbox, CheckboxProps as AntdCheckboxProps, ConfigProvider } from 'antd';
import { CheckboxGroupProps as AntdCheckboxGroupProps } from 'antd/es/checkbox';
import { useTheme } from '../../theme/ThemeContext';

// Define the props type for your custom Checkbox component
export interface CheckboxProps extends AntdCheckboxProps {  "data-test" ?: string;}

// Define the props type for the custom Checkbox.Group component
export interface CheckboxGroupProps extends AntdCheckboxGroupProps {  "data-test" ?: string;}

// Wrapper component for Checkbox
const Checkbox: React.FC<CheckboxProps> & { Group: React.FC<CheckboxGroupProps> } = ({ style, ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdCheckbox {...props} data-test={props['data-test']} data-asper-checkbox/>
        </ConfigProvider>
    );
};

// Wrapper component for Checkbox.Group
const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ style, ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdCheckbox.Group {...props} data-test={props['data-test']} data-asper-checkbox-group/>
        </ConfigProvider>
    );
};

// Attach the Group component to the Checkbox component
Checkbox.Group = CheckboxGroup;

export default Checkbox;
